import { Grid } from 'antd';

const { useBreakpoint } = Grid;
export default function useIsDesktop() {
  const screens = useBreakpoint();
  return screens.lg;
}
